/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DomainaddonsRequestBuilderRequestsMetadata, type DomainaddonsRequestBuilder } from './domainaddons/index.js';
// @ts-ignore
import { InvoiceFeeRequestBuilderRequestsMetadata, type InvoiceFeeRequestBuilder } from './invoiceFee/index.js';
// @ts-ignore
import { Microsoft365RequestBuilderRequestsMetadata, type Microsoft365RequestBuilder } from './microsoft365/index.js';
// @ts-ignore
import { TldRequestBuilderRequestsMetadata, type TldRequestBuilder } from './tld/index.js';
// @ts-ignore
import { type VpsRequestBuilder, VpsRequestBuilderRequestsMetadata } from './vps/index.js';
// @ts-ignore
import { type VpsaddonsRequestBuilder, VpsaddonsRequestBuilderRequestsMetadata } from './vpsaddons/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog
 */
export interface CatalogRequestBuilder extends BaseRequestBuilder<CatalogRequestBuilder> {
    /**
     * The domainaddons property
     */
    get domainaddons(): DomainaddonsRequestBuilder;
    /**
     * The invoiceFee property
     */
    get invoiceFee(): InvoiceFeeRequestBuilder;
    /**
     * The microsoft365 property
     */
    get microsoft365(): Microsoft365RequestBuilder;
    /**
     * The tld property
     */
    get tld(): TldRequestBuilder;
    /**
     * The vps property
     */
    get vps(): VpsRequestBuilder;
    /**
     * The vpsaddons property
     */
    get vpsaddons(): VpsaddonsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CatalogRequestBuilderUriTemplate = "{+baseurl}/catalog";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CatalogRequestBuilderNavigationMetadata: Record<Exclude<keyof CatalogRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    domainaddons: {
        requestsMetadata: DomainaddonsRequestBuilderRequestsMetadata,
    },
    invoiceFee: {
        requestsMetadata: InvoiceFeeRequestBuilderRequestsMetadata,
    },
    microsoft365: {
        requestsMetadata: Microsoft365RequestBuilderRequestsMetadata,
    },
    tld: {
        requestsMetadata: TldRequestBuilderRequestsMetadata,
    },
    vps: {
        requestsMetadata: VpsRequestBuilderRequestsMetadata,
    },
    vpsaddons: {
        requestsMetadata: VpsaddonsRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
